
var fetchedProducts = [];
const apiBaseUrl = "https://app.telloss.com";
let plans = [];
let protectedProducts = [];

document.addEventListener('DOMContentLoaded', function () {
  const today = new Date().toISOString().split('T')[0];
  document.getElementById('birthdate').setAttribute('max', today);
});

window.addEventListener('DOMContentLoaded', function () {
  const adultDogRadio = document.getElementById("adult-dog");
  if (adultDogRadio) {
    adultDogRadio.checked = true;
  }
});

function OpenCompanionClick(stepToShow = null) {
  getCustomMealProductExistsCheck();
  const modal = document.getElementById('wizardModal');
  if (!modal) return;

  // 🔹 Hide all steps before opening to avoid flicker
  const allSteps = document.querySelectorAll('.companion-step');
  allSteps.forEach(step => {
    step.style.display = 'none';
  });

  // 🔹 Open modal first
  modal.classList.add('companion-modal-show');
  document.body.style.overflowY = "hidden";

  // 🔹 If a specific step is requested, show it right away
  if (stepToShow !== null) {
    showStep(stepToShow);
    const stepCurrentNumber = document.querySelector('.step-current-number');
    if (stepCurrentNumber) stepCurrentNumber.innerText = stepToShow;
  }
}

function CloseCompanionClick(MainModalClick){
  if(MainModalClick === 1){ 
    document.getElementById('wizardModal')?.classList.remove('companion-modal-show');
    document.body.style.overflowY = "auto";
    CompanionNextClick(0)
    updateStepIndicator(0);
    resetModalValue();
  } else {
    const totalWeight = getTotalWeight(); // avoid name clash
    if (totalWeight !== 30) {
      document.querySelector('.add_more_item_wrapper').classList.remove('visibility-hidden');
      return false;
    }
    document.querySelector('.add_more_item_wrapper').classList.add('visibility-hidden');
    document.getElementById('hidden_is_subscription').value = 1;

    let iseditSubscription = document.getElementById('subscription_id').value;
    console.log(iseditSubscription);
    setTimeout(() => {
      if(iseditSubscription){
        OpenUpdateConfirmClick();
      }else{
        OpenConfirmClick();
      }
    }, 200);
  }
}

function OpenConfirmClick(){
  document.getElementById('companionConfirmModal')?.classList.add('confirm-modal-show');
}

function OpenUpdateConfirmClick(){
  document.getElementById('qty-modal').classList.add('show');
}

function CloseConfirmClick(){
  document.getElementById('companionConfirmModal')?.classList.remove('confirm-modal-show');

  OpenCompanionClick();
  CompanionPrevClick(5);
  updateStepIndicator(5)
  loader('add_to_cart_btn_1',false);
  loader('add_to_cart_btn_2',false);
}


function OpenOneTimeOrderConfirmClick(){
  document.getElementById('companionOneTimeOrderConfirmModal')?.classList.add('confirm-modal-show');
}

function CloseOneTimeOrderConfirmClick(){
  document.getElementById('companionOneTimeOrderConfirmModal')?.classList.remove('confirm-modal-show');
  loader('add_to_cart_btn_1',false);
  loader('add_to_cart_btn_2',false);
}

function updateStepIndicator(currentStep) {
  const dots = document.querySelectorAll('.step-dot');
  dots.forEach((dot, index) => {
    if (index < currentStep) {
      dot.classList.add('completed');
    } else {
      dot.classList.remove('completed');
    }
    dot.classList.toggle('active', index === currentStep - 1);
  });
  
  const stepNumberEl = document.querySelector('.step-current-number');
  if (stepNumberEl && currentStep <= 5) {
    stepNumberEl.textContent = currentStep;
  }
  
  const completedIcon = document.getElementById('completed-icon');
  if (completedIcon) {
    completedIcon.style.opacity = currentStep >= 5 ? "1" : "0.2";
  }
}


function getPetDetailValue() {
  const nameInput = document.getElementById("name");
  const zipcodeInput = document.getElementById("zipcode");
  const minZipLength = zipcodeInput.getAttribute("maxlength");

  const NextButton = document.getElementById("first-step-start");

  const name = nameInput.value.trim();
  const zipcode = zipcodeInput.value.trim();

  const petNameOnTopBar = document.querySelector('.pet_name_modal_top_bar');
  
  const petNameOnCustomizeText = document.querySelector('.meal_plan_pet_name');

  if (name === "") {
    petNameOnCustomizeText.innerText = "your Pet";
    petNameOnTopBar.innerText = "Your Pet";
    nameInput.classList.add("input-error");
  } else {
    petNameOnCustomizeText.innerText = name.charAt(0).toUpperCase() + name.slice(1);
    petNameOnTopBar.innerText = name.charAt(0).toUpperCase() + name.slice(1);
    nameInput.classList.remove("input-error");
  }
  
  if (zipcode.length != minZipLength) {
    zipcodeInput.classList.add("input-error");
  } else {
    zipcodeInput.classList.remove("input-error");
  }
 

  // Enable button if both are filled
  if (name !== "" && zipcode.length == minZipLength) {
    NextButton.disabled = false;
    NextButton.style.background = "#B60217";
  } else {
    NextButton.disabled = true;
    NextButton.style.background = "#e05967";
  }
}

function getFirstStepValue() {
  const breedElement = document.getElementById("breed");
  const breed = breedElement.value;
  
  const birthdateElement = document.getElementById("birthdate");
  const birthdate = birthdateElement.value;
  const NextButton = document.getElementById("first-step-next");

  // Check if birthday is empty
  if (breed === "") {
    breedElement.classList.add("input-error");
  } else {
    breedElement.classList.remove("input-error");
  }
  
  if (birthdate === "") {
    birthdateElement.classList.add("input-error");
  } else {
    birthdateElement.classList.remove("input-error");
  }
  
  if (birthdate.trim() !== "" && breed.trim() !== "") {
    NextButton.disabled = false;
    NextButton.style.background = "#B60217";
  } else {
    NextButton.disabled = true;
    NextButton.style.background = "#e05967";
  }
}


const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

// Step elements
const beginningSteps = document.getElementById("Content-Step-start");
const StepOne = document.getElementById("Content-Step-One");
const StepTwo = document.getElementById("Content-Step-Two");
const StepThree = document.getElementById("Content-Step-Three");
const StepFour = document.getElementById("Content-Step-Four");
const StepFive = document.getElementById("Content-Step-Five");
const ConfirmationBox = document.getElementById("ConfirmationBox");

// Utility: show only one step at a time
function showStep(step) {
  const steps = [
    beginningSteps,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    ConfirmationBox
  ];
  steps.forEach(el =>
    el?.classList.replace("companion-show-content", "companion-hide-content")
  );

  if (steps[step]) {
    steps[step].classList.replace("companion-hide-content", "companion-show-content");
  }

  const stepDots = document.querySelectorAll('.step-dot');

  
  stepDots.forEach((dot, index) => {
    if (index < step) {
      dot.classList.add('active');
    } else {
      dot.classList.remove('active');
    }
  });
  
}

// Main step handler
function CompanionNextClick(CurrentStep) {

  const petName = document.getElementById("name")?.value?.trim();
  if (petName) {
     // Capitalize first character
    var capitalizedName = petName.charAt(0).toUpperCase() + petName.slice(1);
    const petNameElements = document.querySelectorAll(".pet_name");
    petNameElements.forEach(el => {
      el.textContent = capitalizedName;
    });
  }
  const indicators = document.querySelectorAll('.step-indicator');
  const stepCurrentNumber = document.querySelector('.step-current-number');
  
  if (CurrentStep === 0) {
    
    showStep(0);
    indicators.forEach(el => {
      el.style.visibility = 'hidden';
    });
  }else{
    indicators.forEach(el => {
      el.style.visibility = 'visible';
    });
  }

  if (CurrentStep === 1) {
    showStep(1);
    stepCurrentNumber.innerText = CurrentStep;
  }

  if (CurrentStep === 2) {
    
    const breedElement = document.getElementById("breed");
    const birthdateElement = document.getElementById("birthdate");
    const selectedAnimalType = document.querySelector('input[name="animal_type"]:checked')?.value;

    const breed = breedElement.value?.trim();
    const birthdate = birthdateElement.value?.trim();
    
    if(breed != "" && birthdate != ""){
      showStep(2);

      const petBreedElements = document.querySelectorAll(".pet_breed");
      petBreedElements.forEach(el => {
        el.textContent = capitalize(breed);
      });

      const petTypeElements = document.querySelectorAll(".pet_type");
      petTypeElements.forEach(el => {
        el.textContent = capitalize(selectedAnimalType);
      });



      stepCurrentNumber.innerText = CurrentStep; 
    }else{
      if (breed === "") {
        breedElement.classList.add("input-error");
      } else {
        breedElement.classList.remove("input-error");
      }
      if (birthdate === "") {
        birthdateElement.classList.add("input-error");
      } else {
        birthdateElement.classList.remove("input-error");
      }
      return false
    }
  }
  // if (CurrentStep === 2) {
  //   const FirstStepInput = document.getElementById("breed")?.value?.trim();
  //   if(FirstStepInput != ""){
  //     document.getElementById("hidden_weight").value = FirstStepInput;
  //     showStep(2);
  //     stepCurrentNumber.innerText = CurrentStep; 
  //   }else{
  //     return false
  //   }
  // }

  if (CurrentStep === 3) {
    const weightElement = document.querySelector('input[name="weight"]');
    const weight = weightElement?.value?.trim();
    if (!weight){
       if (weight === "") {
        weightElement.classList.add("input-error");
      } else {
        weightElement.classList.remove("input-error");
      }
      return;
    }else {
        weightElement.classList.remove("input-error");
    }
    showStep(3);
    stepCurrentNumber.innerText = CurrentStep;
  }

  if (CurrentStep === 4) {
    loader('companion_step_four_btn',true)
    stepCurrentNumber.innerText = CurrentStep -1;
    const weight = document.querySelector('input[name="weight"]')?.value?.trim();
    const zipcode = document.querySelector('input[name="zipcode"]')?.value?.trim();
    const selectedAnimalType = document.querySelector('input[name="animal_type"]:checked')?.value;
    const selectedAnimalSubType = "average";
    const targetWeight = document.getElementById('loss_weight')?.value || '';
    let selectedHealthOption = document.querySelector('input[name="target"]:checked').value;

    if (!weight || !selectedAnimalType || !selectedAnimalSubType) return;

    document.getElementById('hidden_animal_sub_type').value = selectedAnimalSubType;
    document.querySelector('.animal_type').innerHTML = selectedAnimalType;
    let grind = "Fine Grinds";
    document.querySelector('.grind_edit_wrapper').style = "display:none;";
    if(selectedAnimalType == "adult dog"){
      document.querySelector('.grind_edit_wrapper').style = "display:block;";
      grind = "Course Grinds";
    }
    document.querySelector('.grind_wrapper').innerHTML = grind;

    const apiUrl = apiBaseUrl + '/api/companion-second-step';
    const formData = {
      useType: 'api',
      animal_sub_type: selectedAnimalSubType,
      animal_type: selectedAnimalType,
      weight: weight,
      zipcode: zipcode,
      targetWeight:targetWeight,
      HealthOption:selectedHealthOption
    };

    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(data => {
        loader('companion_step_four_btn',false)

        
        document.querySelectorAll('.per_day_value').forEach(el => {
          el.innerText = data.dailyFeed;
        });
        
        document.querySelectorAll('.per_day_max_value').forEach(el => {
          el.innerText = data.dailyFeedMax;
        });

        document.querySelectorAll('.body_weight').forEach(el => {
          el.innerText = data.dailyPercent;
        });
     
        document.querySelectorAll('.frequancy').forEach(el => {
          el.innerText = data.frequency;
        });
        document.getElementById('hidden_frequency').value = data.frequency;

        // Hidden inputs
        const inputSelector = 'input.product_price_charge[name="products[charge][id]"]';
        const existingInput = document.querySelector(inputSelector);

        if (!existingInput) {
            const inputId = document.createElement('input');
            inputId.type = 'hidden';
            inputId.name = 'products[charge][id]';
            inputId.className = 'product_price_charge';
            inputId.value = data.shipping_charge;

            document.querySelector('#appendNewInput').appendChild(inputId);
        } else {
            console.log("Input already exists, not appending again.");
        }

        showStep(4);
      })
      .catch(error => {
        loader('companion_step_four_btn',false)
        console.error('API Step 2 Error:', error);
      });
  }

  if (CurrentStep === 5) {
    
    loader('companion_step_five_btn',true)
   
    stepCurrentNumber.innerText = CurrentStep -1;
    const checkboxes = document.querySelectorAll('input[name="sensitivity[]"]:checked');
    const sensitivityValues = Array.from(checkboxes).map(cb => cb.value);
    const frequency = document.getElementById('hidden_frequency')?.value;
    const selectedAnimalType = document.querySelector('input[name="animal_type"]:checked')?.value;
    const petWeight = document.querySelector('input[name="weight"]')?.value;

    const formData = new FormData();
    formData.append('useType', 'api');
    formData.append('weight', petWeight);
    formData.append('animal_type', selectedAnimalType);
    formData.append('frequency', frequency);

    if(selectedAnimalType == 'adult dog'){
      const grind = document.querySelector('input[name="hidden_grind"]')?.value;
      if(grind != ''){
        formData.append('grind', grind);
      }
    }

    sensitivityValues.forEach(value => formData.append('sensitivity[]', value));
    
    apiHandle(formData);

  }
}

function apiHandle(formData){
  const resultListWrapper = document.querySelector('.resultList');
  resultListWrapper.innerHTML = '<div id="wifi-loader"><svg class="circle-outer" viewBox="0 0 86 86"><circle class="back" cx="43" cy="43" r="40"></circle><circle class="front" cx="43" cy="43" r="40"></circle><circle class="new" cx="43" cy="43" r="40"></circle></svg><svg class="circle-middle" viewBox="0 0 60 60"><circle class="back" cx="30" cy="30" r="27"></circle><circle class="front" cx="30" cy="30" r="27"></circle></svg><svg class="circle-inner" viewBox="0 0 34 34"><circle class="back" cx="17" cy="17" r="14"></circle><circle class="front" cx="17" cy="17" r="14"></circle></svg><div class="text" data-text="Searching"></div></div>';
  fetch(apiBaseUrl + '/api/companion-three-step', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        loader('companion_step_five_btn',false)
        const resultList = document.getElementById('resultList');
        resultList.innerHTML = '';
    
        if (Array.isArray(data.results) && data.results.length > 0) {

          // Clear existing fetched products to avoid duplicates
          fetchedProducts = [];
          
          const ul = document.createElement('ul');
          
          plans = data.variants;
          protectedProducts = data.protectedVariants;
          data.results.forEach((item, index) => {
            // 👇 Push each item to the global array
            fetchedProducts.push(item);
            
            const li = document.createElement('li');
            li.className = `li_content_${index} no-bullet`;
            
            // <input type="number" data-weight="${item.weight}" data-index="${index}" value=""/>

            // Add product text
            li.innerHTML = `<div style="display: flex; justify-content: space-between; align-items: center; gap: 10px;"><div style="display: flex; align-items: center; gap: 10px;min-width: 385px;"><img src="${item.image}" class="li_image_${index}" style="width: 50px; height: 50px; object-fit: cover; border-radius: 6px;"><div><span class="li_title_${index}" style="font-weight: bold;">${item.title}</span><div style="display: flex; align-items: center; gap: 5px;"></div><span class="swap-modal-show icon_${index}" data-index="${index}" data-product-id="${item.id}" data-id="${item.sp_product_id}" data-units="${item.units}" data-title="${item.title}" data-price="${item.price}" data-weight="${item.weight}" style="cursor: pointer; font-size: small; text-decoration: underline; color: #b60217;"><a href="#" style="color: #b60217;">Swap Item</a></span></div></div><input type="number" id="qty_input_${index}" value="${item.units}" data-price="${item.price}" data-weight="${item.weight}" min="0" oninput="handleQtyChange(event, ${index})" style="width: 70px; text-align: center;" class="input-box"/><i class="fa fa-trash" style="cursor: pointer;" data-index="${index}" onclick="removeItem(this)"></i></div>`;
    
            // Hidden inputs
            const inputId = document.createElement('input');
            inputId.type = 'hidden';
            inputId.name = `products[${index}][id]`;
            inputId.className = `product_id_${index}`;
            inputId.value = item.id;
    
            const inputUnits = document.createElement('input');
            inputUnits.type = 'hidden';
            inputUnits.name = `products[${index}][units]`;
            inputUnits.className = `product_unit_${index}`;
            inputUnits.value = item.units;

            const inputPrice = document.createElement('input');
            inputPrice.type = 'hidden';
            inputPrice.name = `products[${index}][price]`;
            inputPrice.className = `product_price_${index}`;
            inputPrice.value = item.units * item.price;
            
            const inputWeight = document.createElement('input');
            inputWeight.type = 'hidden';
            inputWeight.name = `products[${index}][weight]`;
            inputWeight.className = `product_weight_${index}`;
            inputWeight.value = item.units * item.weight;
    
            const inputSpId = document.createElement('input');
            inputSpId.type = 'hidden';
            inputSpId.name = `products[${index}][sp_product_id]`;
            inputSpId.className = `product_sp_product_id_${index}`;
            inputSpId.value = item.sp_product_id;
    
            li.appendChild(inputId);
            li.appendChild(inputUnits);
            li.appendChild(inputWeight);
            li.appendChild(inputPrice);
            li.appendChild(inputSpId);
    
            ul.appendChild(li);
          });
    
          resultList.appendChild(ul);
        } else {
          const ul = document.createElement('ul');
          const li = document.createElement('li');
          li.textContent = 'No items found in the response.';
          ul.appendChild(li);
          resultList.appendChild(ul);
        }

        loadProducts();
    
        document.getElementById('total_plan_price').innerText = "Total Plan Price : " + getTotalPrice();
        showStep(5);
        getTotalWeight();
        document.getElementById("completed-icon").style.opacity = "1";
      })
      .catch(error => {
        loader('companion_step_five_btn',false)
        console.error('API Step 3 Error:', error);
        document.getElementById('resultList').innerHTML = '<li>Something went wrong while fetching results.</li>';
      });
}

function loader(className, isShowing) {
  const button = document.querySelector(`.${className}`);
  if (isShowing) {
    // Store original content for later restoration
    if (!button.dataset.originalContent) {
      button.dataset.originalContent = button.innerHTML;
    }
    // Show loader (you can use a spinner icon or dots)
    button.innerHTML = `<span class="spinner"></span> Loading...`;
    button.disabled = true;
  } else {
    // Restore original content
    if (button.dataset.originalContent) {
      button.innerHTML = button.dataset.originalContent;
    }
    button.disabled = false;
  }
}

function removeItem(element){
  const index = element.getAttribute('data-index');
  const targetClass = 'li_content_' + index;
  // Find the element with that class
  const contentElement = document.querySelector('.' + targetClass);

  // Traverse up to the <li> and remove it
  if (contentElement) {
    const li = contentElement.closest('li');
    if (li) {

      // Get values using the index
      const productId = document.querySelector('.product_id_' + index)?.value || '';
      const productWeight = document.querySelector('.product_weight_' + index)?.value || '';
      const productPrice = document.querySelector('.product_price_' + index)?.value || '';
      const spProductId = document.querySelector('.product_sp_product_id_' + index)?.value || '';
      const productImage = document.querySelector('.li_image_' + index)?.getAttribute('src') || '';
      const productTitle = document.querySelector('.li_title_' + index)?.innerText || '';
      const productUnit = document.querySelector('.product_unit_' + index)?.value || '';

      let productTotalWeight = productWeight / productUnit;
      if(productId != 0){
        addOptionToAllSelects(productId, productTitle, spProductId, productTotalWeight, productPrice, productImage);
      }
      li.remove();
    }
  }
  document.getElementById('total_plan_price').innerText = "Total Plan Price : " + getTotalPrice();
  getTotalWeight();
  swapOptionCheck();
}


function CompanionPrevClick(PrevStep){
  updateStepIndicator(PrevStep)
  const StepStart = document.getElementById("Content-Step-start");
  const StepOne = document.getElementById("Content-Step-One");
  const StepTwo = document.getElementById("Content-Step-Two");
  const StepThree = document.getElementById("Content-Step-Three");
  const StepFour = document.getElementById("Content-Step-Four");
  const StepFive = document.getElementById("Content-Step-Five");
  const FifthStepButtons = document.getElementById("FifthStepButtons");
  const ConfirmationBox = document.getElementById("ConfirmationBox");

  if(PrevStep === 0){
    const indicators = document.querySelectorAll('.step-indicator');
    indicators.forEach(el => {
      el.style.visibility = 'hidden';
    });
    StepStart?.classList.replace('companion-hide-content', 'companion-show-content');
    StepOne?.classList.replace('companion-show-content', 'companion-hide-content');
  }else if(PrevStep === 1){
    StepOne?.classList.replace('companion-hide-content', 'companion-show-content');
    StepTwo?.classList.replace('companion-show-content', 'companion-hide-content');
  } else if(PrevStep === 2){
    StepTwo?.classList.replace('companion-hide-content', 'companion-show-content');
    // StepThree?.classList.replace('companion-show-content', 'companion-hide-content');
    StepFour?.classList.replace('companion-show-content', 'companion-hide-content');
  } else if(PrevStep === 3){
    // StepThree?.classList.replace('companion-hide-content', 'companion-show-content');
    // StepFour?.classList.replace('companion-show-content', 'companion-hide-content');
  } else if(PrevStep === 4){
    StepFour?.classList.replace('companion-hide-content', 'companion-show-content');
    StepFive?.classList.replace('companion-show-content', 'companion-hide-content');
  } else if(PrevStep === 5){
    FifthStepButtons?.classList.remove('companion-hide-content');
    ConfirmationBox?.classList.replace('companion-show-content', 'companion-hide-content');
  }
}

function getCookie(name) {
  let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return decodeURIComponent(match[2]);
  return null;
}

function addToCart(){
  const button = document.getElementById('add_to_cart');
  button.disabled = true;
  loader('add_to_cart_btn_1',true);
  loader('add_to_cart_btn_2',true);

  try {
    const selectedAnimalSubType = "average";
    const selectedAnimalType = document.querySelector('input[name="animal_type"]:checked')?.value || '';
    const frequency = document.getElementById('hidden_frequency')?.value || '';
    const weight = document.getElementById('first-step-input')?.value || '';
    const inputs = document.querySelectorAll('input[name^="products["][type="hidden"]');
    const zipcode = document.getElementById("zipcode").value;
    
    const breed = document.getElementById('breed')?.value || '';
    const birthday = document.getElementById('birthdate')?.value || '';
    const name = document.getElementById('name')?.value || '';
    const lossWeight = document.getElementById('loss_weight')?.value || '';
    const isSubscription = document.getElementById('hidden_is_subscription')?.value || 1;
    const PlangrandTotal = getTotalPrice(1);
    let selectedHealthOption = document.querySelector('input[name="target"]:checked').value;
    const shopifyCustomerId = getCookie('wlcCustomer_id');

    const ShippingCharge = document.querySelector('.product_price_charge')?.value || 0;
 
    const products = {};

    // Build product objects from hidden inputs
    inputs.forEach(input => {
      const match = input.name.match(/products\[(\d+)]\[(\w+)]/);
      if (match) {
        const index = match[1];
        const key = match[2];
        if (!products[index]) {
          products[index] = {};
        }
        products[index][key] = input.value;
      }
    });

    const productArray = Object.values(products);

    const formData = new FormData();
    formData.append('PlangrandTotal', PlangrandTotal);
    formData.append('isSubscription', isSubscription);
    formData.append('HealthOption', selectedHealthOption);
    formData.append('name', name);
    formData.append('zip_code', zipcode);
    formData.append('birthday', birthday);
    formData.append('breed', breed);
    formData.append('lossWeight', lossWeight);
    formData.append('weight', weight);
    formData.append('animal_type', selectedAnimalType);
    formData.append('animal_sub_type', selectedAnimalSubType);
    formData.append('frequency', frequency);
    formData.append('shipping_charge', ShippingCharge);
    formData.append('shopify_customer_id', shopifyCustomerId);

    // Only add product if it has required values
    productArray.forEach((product, index) => {
      if (product.id && product.units && product.sp_product_id) {
        formData.append(`products[${index}][id]`, product.id);
        formData.append(`products[${index}][units]`, product.units);
        formData.append(`products[${index}][sp_product_id]`, product.sp_product_id);
      }
    });

    // ✅ Add sensitivity values
    const checkboxes = document.querySelectorAll('input[name="sensitivity[]"]:checked');
    const sensitivityValues = Array.from(checkboxes).map(cb => cb.value);
    sensitivityValues.forEach(sensitivity => {
      formData.append('sensitivity[]', sensitivity);
    });

    fetch(apiBaseUrl + '/api/add-to-cart', {
      method: 'POST',
      body: formData,
    })
      .then(async (response) => {
        const text = await response.text();
        if (!response.ok) {
          console.error('Server Error (500):', text);
          throw new Error('Server returned error response');
        }

        let data;
        try {
          data = JSON.parse(text);
        } catch (err) {
          console.error('Invalid JSON in response:', text);
          throw err;
        }

        if (data.cart_url) {
          window.location.href = data.cart_url;
        } else {
          console.error('cart_url not found in response');
        }

        button.disabled = false;
        loader('add_to_cart_btn_1',false);
        loader('add_to_cart_btn_2',false);

      })
      .catch((error) => {
        console.error('Fetch error:', error);
        button.disabled = false;
      });

  } catch (e) {
    console.error('JavaScript Error:', e.message);
    button.disabled = false;
    loader('add_to_cart_btn_1',false);
    loader('add_to_cart_btn_2',false);
  }
}

document.addEventListener('DOMContentLoaded', async function () {
   const allergyContainer = document.getElementById('MainInputWrapper');

    try {
      const response = await fetch(apiBaseUrl + '/api/allergies'); // 🔁 Replace with your actual API endpoint
      const result = await response.json();
  
      // Check if response is successful
      if (result.status === 'success' && result.data) {
        // Split the data string into an array
        const allergies = result.data.split(',');
  
        // Shopify customer tags (from Liquid)
        const customerTags = "{{ customer.tags | escape }}".toLowerCase().split(',');
  
        allergyContainer.innerHTML = '';
  
        allergies.forEach(item => {
          const itemLower = item.toLowerCase().trim();
          const isChecked = customerTags.includes(itemLower) ? 'checked' : '';
  
          allergyContainer.innerHTML += `
            <label class='sensitivity_label'>
              <div class="checkbox-wrapper">
                <input type="checkbox" class="file-input" name="sensitivity[]" value="${itemLower}" style="margin: 0"  ${isChecked} onchange="handleCheckboxChange(this)">
                <i class="ban-icon fa fa-ban" style="display: none; margin-left: 5px;"></i>
              </div>
              <span class="label-text" onclick="handleCheckboxChange(this)">${item}</span>
            </label>
          `;
        });
      } else {
        allergyContainer.innerHTML = 'No allergies found.';
      }
  
    } catch (err) {
      allergyContainer.innerHTML = 'Failed to load allergies.';
      console.error('Error loading allergies:', err);
    }
});

function handleCheckboxChange(triggerElement) {
  const label = triggerElement.closest('.sensitivity_label');
  const checkbox = label.querySelector('.file-input');
  const icon = label.querySelector('.ban-icon');
  const labelText = label.querySelector('.label-text');

  // Toggle the checkbox state if clicked on label text
  if (triggerElement.classList.contains('label-text')) {
    checkbox.checked = !checkbox.checked;
  }

  if (checkbox.checked) {
    checkbox.classList.add('is-checked');
    labelText.classList.add('strikethrough');
    icon.style.display = 'inline';
  } else {
    checkbox.classList.remove('is-checked');
    labelText.classList.remove('strikethrough');
    icon.style.display = 'none';
  }
}


const radioButtons = document.querySelectorAll('input[name="target"]');
const targetDiv = document.getElementById('weight-loss_input_wrapper');

radioButtons.forEach(radio => {
  radio.addEventListener('change', () => {
    const selected = document.querySelector('input[name="target"]:checked');
    if (selected?.value === 'weight_loss') {
      targetDiv.style.display = 'block';
    } else {
      targetDiv.style.display = 'none';
    }
  });
});

function setLossWeight(){
  const weight = document.querySelector('input[name="weight"]')?.value?.trim();
  const companionStepFourBtn = document.querySelectorAll('.companion_step_four_btn');
  if (weight) {
      companionStepFourBtn.forEach(button => {
        button.removeAttribute('disabled'); // Remove disabled attribute
        button.style.backgroundColor = 'rgb(182, 2, 23)';
      });
      document.querySelector('input[name="loss_weight"]').value = weight;
  }else{
     companionStepFourBtn.forEach(button => {
        button.setAttribute('disabled', 'disabled');
        button.style.backgroundColor = 'rgb(224, 89, 103)'; 
      });
  }
}

// swap modal js
document.addEventListener('click', function(e) {
  const target = e.target.closest('.swap-modal-show');
  if (target) {
    const spTitle = target.getAttribute('data-title');
    const spId = target.getAttribute('data-id');
    const productId = target.getAttribute('data-product-id');
    const units = target.getAttribute('data-units');
    const index = target.getAttribute('data-index');
    const weight = target.getAttribute('data-weight');
    const price = target.getAttribute('data-price');

    // Populate modal content
    document.getElementById('modalWeight').value = weight;
    document.getElementById('modalIndex').value = index;
    document.getElementById('modalSpTitle').value = spId;
    document.getElementById('modalProductPrice').value = price;
    document.getElementById('modalSpId').textContent = spTitle;
    document.getElementById('modalProductId').value = productId;
    document.getElementById('modalUnits').textContent = units;

    // Show modal
    document.getElementById('swapModal').style.display = 'block';
  }
});

function closeModal() {
  document.getElementById('swapModal').style.display = 'none';
  document.getElementById('addItemModal').style.display = 'none';
}

let currentSwapIcon = null;

function submitSwap() {
  const selectedProduct = document.getElementById('productDropdown');
  const selectedOption = selectedProduct.options[selectedProduct.selectedIndex];
  
  const newProductId = selectedOption.value;
  const newTitle = selectedOption.text;
  const newSpProductId = selectedOption.getAttribute('data-spid');
  const newProductWeight = selectedOption.getAttribute('data-weight');
  const newProductPrice = selectedOption.getAttribute('data-price');
  const newProductimage = selectedOption.getAttribute('data-image-url');

  
  const modalIndex = document.getElementById('modalIndex').value;
  const weight =document.getElementById('modalWeight').value;
  const oldProductId =document.getElementById('modalProductId').value;
  const spId =document.getElementById('modalSpTitle').value;
  const oldPrice = document.getElementById('modalProductPrice').value;
  const oldTitle = document.getElementById('modalSpId').innerText;
  const units = document.getElementById('modalUnits').innerText;
  const oldImgElement = document.querySelector('.li_image_' + modalIndex).src;

  const deductWeight = units * weight;
  if (!newProductId) {
    alert("Please select a product to swap.");
    return;
  }
  var totalWeight = getTotalWeight(deductWeight);
  const newUnits = 0;

  // Calculate max units that can be added without exceeding 30 lbs
  let remainingWeight = 30 - totalWeight;
  let maxUnits = Math.floor(remainingWeight / newProductWeight);
  
  // if(getTotalWeight(deductWeight) >= 30){
  //   alert("allow only 30lbs product weight in box so please replace other product ");
  //   return;
  // }
  if(oldProductId != 0){
    addOptionToAllSelects(oldProductId, oldTitle, spId, weight, oldPrice, oldImgElement);
  }
  removeOptionFromAllSelects(newProductId);
            
  const liElement = document.querySelector('.li_title_' + modalIndex);
  if (liElement) {
    liElement.innerHTML = newTitle;
  }
  const imgElement = document.querySelector('.li_image_' + modalIndex);
  if (imgElement) {
    imgElement.src = newProductimage;
  }

  const icon = document.querySelector('.icon_' + modalIndex);
  if (icon) {
    const link = icon.querySelector('a'); // find <a> inside the span
    if (link) {
        link.innerHTML = 'Swap Item'; // change text or HTML
        // link.innerHTML = '<i class="fa fa-check"></i>'; // example with icon
    }
    icon.setAttribute('data-id', newSpProductId);
    icon.setAttribute('data-title', newTitle);
    icon.setAttribute('data-product-id', newProductId);
    icon.setAttribute('data-units', units);
    icon.setAttribute('data-weight', newProductWeight);
    icon.setAttribute('data-price', newProductPrice);
  }

  let QtyInput = document.getElementById('qty_input_'+ modalIndex);
  if(QtyInput){
    QtyInput.setAttribute('data-weight', newProductWeight);
    QtyInput.setAttribute('data-price', newProductPrice);
  }


  const productIdHiddenInput = document.querySelector('.product_id_' + modalIndex);
  const productUnitHiddenInput = document.querySelector('.product_unit_' + modalIndex);
  const productSpIdHiddenInput = document.querySelector('.product_sp_product_id_' + modalIndex);
  const productPriceHiddenInput = document.querySelector('.product_price_' + modalIndex);
  const productWeightHiddenInput = document.querySelector('.product_weight_' + modalIndex);

  // Set new values (these variables should be defined beforehand)
  if (productIdHiddenInput) productIdHiddenInput.value = newProductId;
  if (productUnitHiddenInput) productUnitHiddenInput.value = units;
  if (productSpIdHiddenInput) productSpIdHiddenInput.value = newSpProductId;
  if (productPriceHiddenInput) productPriceHiddenInput.value = units * newProductPrice;
  if (productWeightHiddenInput) productWeightHiddenInput.value = units * newProductWeight;

  // 'li_content_' + modalIndex
  let liFindElement = document.querySelector('.li_content_' + modalIndex);
  
  if (liFindElement && liFindElement.classList.contains('more_pound_item')) {
      liFindElement.classList.remove('more_pound_item');
  }

  document.getElementById('total_plan_price').innerText = "Total Plan Price : " + getTotalPrice();
  getTotalWeight();
  swapOptionCheck();
  closeModal();
}

function removeOptionByValue(dropdownId, valueToRemove) {
  const dropdown = document.getElementById(dropdownId);
  if (!dropdown) return;

  const options = dropdown.options;
  for (let i = options.length - 1; i >= 0; i--) {
    if (options[i].value === valueToRemove) {
      dropdown.remove(i);
    }
  }
}

function loadProducts() {
  const checkboxes = document.querySelectorAll('input[name="sensitivity[]"]:checked');
  const sensitivityValues = Array.from(checkboxes).map(cb => cb.value);
  const frequency = document.getElementById('hidden_frequency')?.value;
  const selectedAnimalType = document.querySelector('input[name="animal_type"]:checked')?.value;
  const petWeight = document.querySelector('input[name="weight"]')?.value;
  
  // Build query params
  const params = new URLSearchParams();
  
  params.append('weight', petWeight);
  params.append('animal_type', selectedAnimalType);
  params.append('frequency', frequency);
  
  // Append each sensitivity[]
  sensitivityValues.forEach(value => {
    params.append('sensitivity[]', value);
  });

  
  // Final URL
  const url = `${apiBaseUrl}/api/get-swap-products?${params.toString()}`;
  fetch(url)
    .then(res => res.json())
    .then(data => {
      const dropdown = document.getElementById('productDropdown');
      const addDropdown = document.getElementById('addproductDropdown');
      dropdown.innerHTML = '<option value="">-- Choose Product --</option>';
      addDropdown.innerHTML = '<option value="">-- Choose Product --</option>';

      if (data.products && Array.isArray(data.products)) {
        data.products.forEach(product => {
          const alreadyFetched = fetchedProducts.some(p => p.id === product.id);
            if (!alreadyFetched) {
              // To add an option to all selects
              addOptionToAllSelects(product.id, product.title, product.sp_product_id, product.weight, product.price, product.image);
            }
        });
      }
      swapOptionCheck();
    })
    .catch(err => {
      console.error("Failed to load swap products:", err);
    });
}

function handleFinishButtonClick(event) {
  const totalWeight = getTotalWeight(); // avoid name clash
  if (totalWeight !== 30) {
    document.querySelector('.add_more_item_wrapper').classList.remove('visibility-hidden');
    return false;
  }
  document.querySelector('.add_more_item_wrapper').classList.add('visibility-hidden');
  document.getElementById('hidden_is_subscription').value = event;
  OpenOneTimeOrderConfirmClick();
}

function getTotalWeight(deductWeight = 0) {
    let totalWeight = 0;
    document.querySelectorAll('[class^="product_weight_"]').forEach(input => {
      totalWeight += parseFloat(input.value) || 0;
    });
    totalWeight -= deductWeight;

    if(totalWeight >= 30){
      const contentElement = document.querySelector('.more_pound_item');
      if(contentElement){
        const li = contentElement.closest('li');
        if (li) {
          li.remove();
        }
      }
    }else{
      let requiredWeight = 30 - totalWeight;
      if(document.querySelectorAll('.more_pound_item').length < 1){
        let productId = 0;
        let weight = 0;
        let price = 0;
        let quantity = 1;
        let spId = 0;
        let totalPrice = 0;
        let MorePounttotalWeight = 0;
        let imageUrl = "https://app.telloss.com/assets/images/products/default_product.png";
        let title = "<span class='required_weight'>"+requiredWeight+"</span> More Pounds required";
        let title1 = requiredWeight+" More Pounds required";
  
        let itemIndex = getNextLiIndex();
        const li = document.createElement('li');
        li.className = `li_content_${itemIndex} no-bullet more_pound_item`;
  
        li.innerHTML = `
          <div style="display: flex; justify-content: space-between; align-items: center; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 10px; min-width: 385px;">
              <img src="${imageUrl}" class="li_image_${itemIndex}" style="width: 50px; height: 50px; object-fit: cover; border-radius: 6px;">
              <div>
                <span class="li_title_${itemIndex}" style="font-weight: bold;">${title}</span>
                <div style="display: flex; align-items: center; gap: 5px;"></div>
                <span class="require-pound-tab swap-modal-show icon_${itemIndex}" data-index="${itemIndex}" data-product-id="${productId}" data-id="${spId}" data-units="${quantity}" data-title="${title1}" data-price="${price}" data-weight="${MorePounttotalWeight}" style="cursor: pointer; font-size: small; text-decoration: underline; color: #b60217;">
                  <a href="#" style="color: #b60217;">Select Item</a>
                </span>
              </div>
            </div>
            <input type="number" id="qty_input_${itemIndex}" value="${quantity}" min="0" data-price="${price}" data-weight="${MorePounttotalWeight}" oninput="handleQtyChange(event, ${itemIndex})" style="width: 70px; text-align: center;" class="input-box">
            <i class="fa fa-trash" style="cursor: pointer;" data-index="${itemIndex}" onclick="removeItem(this)"></i>
          </div>
  
          <input type="hidden" name="products[${itemIndex}][id]" class="product_id_${itemIndex}" value="${productId}">
          <input type="hidden" name="products[${itemIndex}][units]" class="product_unit_${itemIndex}" value="${quantity}">
          <input type="hidden" name="products[${itemIndex}][weight]" class="product_weight_${itemIndex}" value="${MorePounttotalWeight}">
          <input type="hidden" name="products[${itemIndex}][price]" class="product_price_${itemIndex}" value="${totalPrice}">
          <input type="hidden" name="products[${itemIndex}][sp_product_id]" class="product_sp_product_id_${itemIndex}" value="${spId}">
        `;
  
        // Append to product list
        document.querySelector('#resultList ul').appendChild(li);
      }
      document.querySelector('.required_weight').innerText = requiredWeight; 
      document.querySelector('.require-pound-tab').dataset.title = requiredWeight + ' More Pounds required'; 
    }
    if (totalWeight != 30) {
      document.querySelector('.total_weight_wrapper').style.color = "red";
    } else {
      document.querySelector('.total_weight_wrapper').style.color = "#513030"; // reset to default if it's 30
    }
    document.querySelector('.add_more_item_wrapper').classList.add('visibility-hidden');
    document.querySelector('.total_weight').innerText = totalWeight;
    return totalWeight;
}

function getTotalPrice(isGetCurrencyIcon = 0) {
    let totalPrice = 0;
    document.querySelectorAll('[class^="product_price_"]').forEach(input => {
      totalPrice += parseFloat(input.value) || 0;
    });
    const roundedPrice = getNextPrice(totalPrice);
    if(isGetCurrencyIcon == 1){
        return roundedPrice;
    }else{
        return '$'+roundedPrice;
    }
}

function getNextPrice(currentPrice) {
  let adjustedPrice = currentPrice;
  const planPrices = plans.map(plan => parseFloat(plan.price));
  const nextEligiblePlanPrice = planPrices.find(price => price > adjustedPrice);

  return nextEligiblePlanPrice ? nextEligiblePlanPrice.toFixed(2) : adjustedPrice.toFixed(2);
}


function addItemModal(){
    document.getElementById('addItemModal').style.display = 'block';
}


function getNextLiIndex() {
  const elements = document.querySelectorAll('[class^="li_content_"]');
  let maxIndex = 0;

  elements.forEach(el => {
    const match = el.className.match(/li_content_(\d+)/);
    if (match) {
      const index = parseInt(match[1], 10);
      if (index > maxIndex) maxIndex = index;
    }
  });

  return maxIndex + 1;
}

function addItem(){
  const productDropdown = document.getElementById('addproductDropdown');
  const quantityInput = document.getElementById('quantity');

  const selectedOption = productDropdown.options[productDropdown.selectedIndex];

  const productId = selectedOption.value;
  const quantity = parseInt(quantityInput.value);
  const spId = selectedOption.getAttribute('data-spid');
  const weight = parseFloat(selectedOption.getAttribute('data-weight'));
  const price = parseFloat(selectedOption.getAttribute('data-price'));
  const imageUrl = selectedOption.getAttribute('data-image-url');
  const title = selectedOption.text;

  let itemIndex = getNextLiIndex();

  // Validation
  if (!productId) {
    alert('Please select a product.');
    productDropdown.focus();
    return;
  }

  if (isNaN(quantity) || quantity <= 0) {
    alert('Please enter a valid quantity greater than 0.');
    quantityInput.focus();
    return;
  }

  const totalWeight = quantity * weight;
  const totalPrice = (price * quantity).toFixed(2);

  // Create the <li> element with same structure
  const li = document.createElement('li');
  li.className = `li_content_${itemIndex} no-bullet`;

  li.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; gap: 10px;">
      <div style="display: flex; align-items: center; gap: 10px; min-width: 385px;">
        <img src="${imageUrl}" class="li_image_${itemIndex}" style="width: 50px; height: 50px; object-fit: cover; border-radius: 6px;">
        <div>
          <span class="li_title_${itemIndex}" style="font-weight: bold;">${title}</span>
          <div style="display: flex; align-items: center; gap: 5px;"></div>
          <span class="swap-modal-show icon_${itemIndex}" data-index="${itemIndex}" data-product-id="${productId}" data-id="${spId}" data-units="${quantity}" data-title="${title}" data-price="${price}" data-weight="${weight}" style="cursor: pointer; font-size: small; text-decoration: underline; color: #b60217;">
            <a href="#" style="color: #b60217;">Swap Item</a>
          </span>
        </div>
      </div>
      <input type="number" id="qty_input_${itemIndex}" value="${quantity}" min="0" data-price="${price}" data-weight="${weight}" oninput="handleQtyChange(event, ${itemIndex})" style="width: 70px; text-align: center;" class="input-box">
      <i class="fa fa-trash" style="cursor: pointer;" data-index="${itemIndex}" onclick="removeItem(this)"></i>
    </div>

    <input type="hidden" name="products[${itemIndex}][id]" class="product_id_${itemIndex}" value="${productId}">
    <input type="hidden" name="products[${itemIndex}][units]" class="product_unit_${itemIndex}" value="${quantity}">
    <input type="hidden" name="products[${itemIndex}][weight]" class="product_weight_${itemIndex}" value="${totalWeight}">
    <input type="hidden" name="products[${itemIndex}][price]" class="product_price_${itemIndex}" value="${totalPrice}">
    <input type="hidden" name="products[${itemIndex}][sp_product_id]" class="product_sp_product_id_${itemIndex}" value="${spId}">
  `;

  // Append to product list
  document.querySelector('#resultList ul').appendChild(li);

  itemIndex++; // Increase the index for next item
  document.getElementById('total_plan_price').innerText = "Total Plan Price : " + getTotalPrice();
  removeOptionFromAllSelects(productId);
  getTotalWeight();
  closeModal(); // Close modal after adding
}




function removeOptionFromAllSelects(oldProductId) {
  const allSelects = document.querySelectorAll('.productDropdown');

  allSelects.forEach(select => {
    [...select.options].forEach(option => {
      if (option.value === oldProductId) {
        select.removeChild(option);
      }
    });
  });
}


function addOptionToAllSelects(oldProductId, oldTitle, spId, weight, oldPrice, oldImgElement) {
  const allSelects = document.querySelectorAll('.productDropdown');

  allSelects.forEach(select => {
    // Check if option already exists
    const exists = [...select.options].some(option => option.value === oldProductId);
    if (!exists) {
      const newOption = document.createElement('option');
      newOption.value = oldProductId;
      newOption.text = oldTitle;
      newOption.setAttribute('data-spid', spId);
      newOption.setAttribute('data-weight', weight);
      newOption.setAttribute('data-price', oldPrice);
      newOption.setAttribute('data-image-url', oldImgElement);

      select.appendChild(newOption);
    }
  });
}

function handleQtyChange(event, index) {
  const newQty = parseInt(event.target.value);
  
  const weight = parseFloat(event.target.dataset.weight);
  const price = parseFloat(event.target.dataset.price);

  // Update hidden inputs
  document.querySelector(`.product_unit_${index}`).value = newQty;
  document.querySelector(`.product_price_${index}`).value = (price * newQty).toFixed(2);
  document.querySelector(`.product_weight_${index}`).value = (weight * newQty).toFixed(2);

  const icon = document.querySelector('.icon_' + index);
  if (icon) {
    icon.setAttribute('data-units', newQty);
    icon.setAttribute('data-weight', weight);
    icon.setAttribute('data-price', price);
  }

  document.getElementById('total_plan_price').innerText = "Total Plan Price : " + getTotalPrice();
  
  getTotalWeight();

}

function swapOptionCheck(){
  let count = $("#productDropdown option").filter(function() {
      return $(this).val().trim() !== "";
  }).length;
  
  if(count <= 0){
    document.querySelectorAll('.swap-modal-show').forEach(el => el.classList.add('visibility-hidden'));
  }else{
    document.querySelectorAll('.swap-modal-show').forEach(el => el.classList.remove('visibility-hidden'));

  }
}

// scout round 2 js 

const editFreequancyBtn = document.getElementById("editFreequancyBtn");
let spamFreequancy = document.getElementById("last_step_freequancy"); // use let so we can reassign

editFreequancyBtn.addEventListener("click", function () {
  if (editFreequancyBtn.getAttribute("data-mode") === "edit") {
    // 👉 Switch to submit mode
    const currentFreequancy = spamFreequancy.textContent.trim();

    // Create dropdown
    const select = document.createElement("select");
    select.id = "freequancySelect";

    for (let i = 1; i <= 12; i++) {
      const option = document.createElement("option");
      option.value = i;
      option.textContent = i;
      if (i == currentFreequancy) option.selected = true; // preselect
      select.appendChild(option);
    }

    // Replace span with dropdown
    spamFreequancy.replaceWith(select);

    // Update reference (now span is gone)
    spamFreequancy = select;

    // Change button to "Submit"
    editFreequancyBtn.innerHTML = '<i class="fa fa-check"></i> Submit';
    editFreequancyBtn.setAttribute("data-mode", "submit");

  } else {
    // 👉 Switch back to edit mode
    const select = document.getElementById("freequancySelect");
    const newValue = select.value;

    // Create new span
    const newSpan = document.createElement("span");
    newSpan.id = "last_step_freequancy";
    newSpan.className = "frequancy"; // ✅ correct way
    newSpan.textContent = newValue;

    document.getElementById('hidden_frequency').value = newValue;

    document.querySelectorAll('.frequancy').forEach(el => {
      el.innerText = newValue;
    });

    // Replace dropdown with span
    select.replaceWith(newSpan);

    // Update reference
    spamFreequancy = newSpan;

    calculateFeedFromFrequencyWeeks(newValue,30);

    // Change button back to "Edit"
    editFreequancyBtn.innerHTML = '<i class="fa fa-edit"></i> Change';
    editFreequancyBtn.setAttribute("data-mode", "edit");
  }
});

const editButton = document.getElementById('feed_edit_button');
const perDayValue = document.getElementById('per_day_value');

editButton.addEventListener('click', function () {
  const selectedAnimalType = document.querySelector('input[name="animal_type"]:checked')?.value;

  if (editButton.getAttribute('data-mode') !== 'edit') {
    // Currently in submit mode → save value
    const input = document.getElementById('per_day_input');
    // const select = document.getElementById('per_day_select');
    
    perDayValue.style.display = "inline";
    perDayValue.innerHTML = `<span id="per_day_value" class="per_day_value">${input.value}</span>`;
    var result = calculateFeedRange(input.value, 30);
    if (input) input.remove();
    editButton.innerHTML = '<i class="fa fa-edit"></i> Change';
    editButton.setAttribute('data-mode', 'edit');
  } else {
    // Currently in edit mode → show input
    const currentValue = perDayValue.textContent.trim();
    const input = document.createElement("input");
    input.type = "number";
    input.value = currentValue.split(" (")[0] || "";
    input.id = "per_day_input";
    input.style = "width:50px;";

    perDayValue.style.display = "none";
    perDayValue.style = "width:50px";
    perDayValue.innerHTML = `<input type="number" id="per_day_input" value="${perDayValue.textContent.trim()}">`;

    editButton.innerHTML = '<i class="fa fa-check"></i> Submit';
    editButton.setAttribute('data-mode', 'submit');
  }
});

function calculateFeedRange(dailyFeedMin, boxWeight) {
  // ensure inputs are numbers
  dailyFeedMin = Number(dailyFeedMin);
  boxWeight = Number(boxWeight);

  // total days a box will last
  const frequencyDays = Math.ceil(boxWeight / dailyFeedMin);


  // convert days to weeks (minimum 1 week)
  let frequencyWeeks = Math.floor(frequencyDays / 7);
  if (frequencyWeeks === 0) {
    frequencyWeeks = 1;
  }

  // max feed per day (spread box evenly across days)
  let dailyFeedMax = dailyFeedMin + 0.1;

  // round values to 1 decimal
  dailyFeedMin = Number(dailyFeedMin.toFixed(1));
  dailyFeedMax = Number(dailyFeedMax.toFixed(1));

  // update DOM
  document.querySelectorAll('.per_day_value').forEach(el => {
    el.innerText = dailyFeedMin;
  });

  document.querySelectorAll('.per_day_max_value').forEach(el => {
    el.innerText = dailyFeedMax;
  });

  document.querySelectorAll('.frequancy').forEach(el => {
    el.innerText = frequencyWeeks;
  });

  document.getElementById('hidden_frequency').value = frequencyWeeks;

  return {
    frequencyWeeks,
    dailyFeedMin,
    dailyFeedMax
  };
}

const grindEditButton = document.getElementById('grind_edit_button');
const grindWrapper = document.getElementById('grind_wrapper');

grindEditButton.addEventListener('click', function () {
  if (grindEditButton.getAttribute('data-mode') !== 'edit') {
    // Currently in submit mode → save value
    const hiddengrind = document.getElementById('hidden_grind');
    const select = document.getElementById('grind_select');
    const selectedText = select.options[select.selectedIndex].text;
    hiddengrind.value = select.value;
    grindWrapper.innerHTML = `<span id="grind_value" class="grind_value">${selectedText}</span>`;

    grindEditButton.innerHTML = '<i class="fa fa-edit"></i> Change';
    grindEditButton.setAttribute('data-mode', 'edit');
  } else {
    const selectedAnimalType = document.querySelector('input[name="animal_type"]:checked')?.value;
    // Currently in edit mode → show select box
    grindWrapper.innerHTML = `
    <select id="grind_select">
      <option value="fine" ${selectedAnimalType == "puppy" ? "selected" : ""}>Fine Grinds</option>
      <option value="coarse" ${selectedAnimalType == "adult dog" ? "selected" : ""}>Coarse Grinds</option>
    </select>
  `;

    grindEditButton.innerHTML = '<i class="fa fa-check"></i> Submit';
    grindEditButton.setAttribute('data-mode', 'submit');
  }
});

function calculateFeedFromFrequencyWeeks(frequencyWeeks, boxWeight) {
  // ensure inputs are numbers
  frequencyWeeks = Number(frequencyWeeks);
  boxWeight = Number(boxWeight);

  // convert weeks to days
  const frequencyDays = frequencyWeeks * 7;

  // calculate per day feed (min)
  let dailyFeedMin = boxWeight / frequencyDays;

  // calculate per day feed (max) → always 0.1 higher
  let dailyFeedMax = dailyFeedMin + 0.1;

  // round to 1 decimal
  dailyFeedMin = Number(dailyFeedMin.toFixed(1));
  dailyFeedMax = Number(dailyFeedMax.toFixed(1));

  // update DOM
  document.querySelectorAll('.per_day_value').forEach(el => {
    el.innerText = dailyFeedMin;
  });

  document.querySelectorAll('.per_day_max_value').forEach(el => {
    el.innerText = dailyFeedMax;
  });

  document.getElementById('hidden_frequency').value = frequencyWeeks;

  return {
    frequencyWeeks,
    frequencyDays,
    dailyFeedMin,
    dailyFeedMax
  };
}

function resetModalValue(){
    // Reset text inputs
    document.getElementById('name').value = '';
    document.getElementById('zipcode').value = '';
    document.getElementById('breed').value = '';
    document.getElementById('birthdate').value = '';
    document.getElementById('first-step-input').value = '';
    document.getElementById('loss_weight').value = '';

    // Reset radio buttons
    document.querySelector(`input[name="animal_type"][value="adult dog"]`).checked = true;
    document.querySelector(`input[name="target"][value="healthy"]`).checked = true;

    getPetDetailValue();
    getFirstStepValue();
    setLossWeight()
    
    const targetDiv = document.getElementById('weight-loss_input_wrapper');
    targetDiv.style.display = 'none';

    const oneTimeBtn = document.querySelector('.one-time-order-btn');
    const subscriptionBtn = document.querySelector('.subscription-button');

    // Hide the "Order One Time" button
    oneTimeBtn.style.display = 'block';

    // Change "Activate Subscription" button text and styling
    subscriptionBtn.textContent = 'Active Subscription';

    document.getElementById('subscription_id').value = "";
    document.querySelectorAll('input[name="sensitivity[]"]').forEach(checkbox => {
      if (checkbox.checked) {
        checkbox.click(); // triggers real click so all UI/event logic runs
      }
    });


}